<div class="row justify-content-center">
  <div class="col-md-10">
    <div class="card card-secondary">
      <div class="card-header">
        <h4 class="card-title w-100">
          <span>Assistant Access</span>
        </h4>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row justify-content-center">
        <div class="col-md-10">
          <div class="formheadertext text-justify">
            <p>
              You can designate one (or more) of your staff to have access to your portal account configuration,
              but from his/her own login. When your designee uses the Agent Portal "Assist Mode", anything they
              do will appear as if you did it yourself, therefore you are responsible for their actions and use
              of data under the confidentiality and data-protection provisions of your contract with Liberty Bankers
              Insurance Group. It is your responsibility to maintain this access - including modifying access dates
              or deleting access entirely when your staff changes.
            </p>
            <p>
              Simply provide the user's email address (that they will establish their own login/account with) as well
              as access dates below; our system will automatically send them an invitation via email with key details.
              The invitation will mention the importance of acting in accordance with your contracted terms of use, but
              we appreciate you for personally reinforcing the criticality of protecting our client's data at all times.
            </p>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showAddButton && !profile.isAssisting">
      <div class="text-center mb-4">
        <input type="button" class="btn btn-secondary input-block-level" value="Add Access" (click)="onAddClicked()">
      </div>
    </ng-container>
    <div class="row admin-box" *ngIf="showList">
      <div #gridWrapper class="col-md-12">
        <ag-grid-angular style="height: 500px;"
                         class="ag-theme-alpine"
                         [rowData]="invitations$ | async"
                         [columnDefs]="columnDefs"
                         [defaultColDef]="defaultColumnDef"
                         rowSelection='single'
                         [suppressRowClickSelection]="true"
                         (gridReady)="onGridReady($event)"
                         [overlayNoRowsTemplate]="noRowsTemplate"
                         (rowClicked)="onRowClicked($event)">
        </ag-grid-angular>
      </div>
    </div>
    <div class="card card-primary" id="InvitationDetails" *ngIf="showDetail">
      <div class="card-header">
        <div class="row">
          <div class="col-md-10">
            <h4 class="card-title w-100">
              <span>Invitation Detail</span>
            </h4>
          </div>
          <div class="col-md-2 my-auto text-right">
            <i class="fas fa-2x fa-times-circle" style="cursor:pointer" (click)="closeDetail()"></i>
          </div>
        </div>
      </div>
      <ng-container *ngIf="showUpdateForm">
        <form #userAssistUpdateForm="ngForm" (ngSubmit)="updateInvitation(userAssistUpdateForm.value)">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>User Assistant</label>
                  <input type="text" class="form-control" name="selectedAssistUserEmail" id="selectedAssistUserEmail" [(ngModel)]="selectedAssistUserEmail" readonly>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Start Date</label>
                  <input type="text" class="form-control date-slashes" name="assistUserStartDate" id="assistUserStartDate" placeholder="enter start date as mm/dd/yyyy" maxlength="10" [class.is-invalid]="startDateError"
                         [ngModel]="selectedAssistUserStartDate" (ngModelChange)="selectedAssistUserStartDate = maskDate($event)" (focus)="inputFocused($event)" (blur)="onStartDateBlur()">
                  <small *ngIf="startDateError" class="form-text text-danger">{{ startDateError }}</small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>End Date</label>
                  <input type="text" class="form-control date-slashes" name="assistUserEndDate" id="assistUserEndDate" placeholder="enter end date as mm/dd/yyyy or click No End Date" maxlength="10" [disabled]="isNoEndDate" [class.is-invalid]="endDateError"
                         [ngModel]="assistUserEndDateDisplay" (ngModelChange)="assistUserEndDateDisplay = maskDate($event)" (focus)="inputFocused($event)" (blur)="onEndDateBlur()">
                  <small *ngIf="endDateError" class="form-text text-danger">{{ endDateError }}</small>
                  <div class="form-check text-right">
                    <input class="form-check-input" type="checkbox" name="noEndDate" id="noEndDate" [(ngModel)]="isNoEndDate" (change)="checkNoEndDate($event)">
                    <label class="form-check-label mr-1 mt-1" for="noEndDate">
                      No End Date
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="text-center">
              <div *ngIf="updateErrorMessage" class="alert alert-danger" role="alert">
                {{ updateErrorMessage }}
              </div>
              <input type="submit" class="btn btn-secondary input-block-level" name="updateButton" id="updateButton" [value]="saving ? 'Saving…' : 'Update'" [disabled]="saving">&nbsp;&nbsp;&nbsp;
              <input type="button" class="btn btn-danger input-block-level" value="Delete" (click)="deleteInvitation()" [disabled]="saving">
            </div>
          </div>
        </form>
      </ng-container>
      <ng-container *ngIf="showAddForm">
        <form #userAssistAddForm="ngForm" (ngSubmit)="addInvitation(userAssistAddForm.value)">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="addAssistUserEmail">User Assistant</label>
                  <input type="text" class="form-control" name="addAssistUserEmail" id="addAssistUserEmail" placeholder="enter email address" maxlength="254" required [class.is-invalid]="emailError"
                         [(ngModel)]="selectedAssistUserEmail" (blur)="onEmailBlur()">
                  <small *ngIf="emailError" class="form-text text-danger">{{ emailError }}</small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Start Date</label>
                  <input type="text" class="form-control date-slashes" name="addAssistUserStartDate" id="addAssistUserStartDate" placeholder="enter start date as mm/dd/yyyy" maxlength="10" [class.is-invalid]="startDateError"
                         [ngModel]="selectedAssistUserStartDate" (ngModelChange)="selectedAssistUserStartDate = maskDate($event)" (focus)="inputFocused($event)" (blur)="onStartDateBlur()">
                  <small *ngIf="startDateError" class="form-text text-danger">{{ startDateError }}</small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>End Date</label>
                  <input type="text" class="form-control date-slashes" name="addAssistUserEndDate" id="addAssistUserEndDate" placeholder="enter end date as mm/dd/yyyy or click No End Date" maxlength="10" [disabled]="isNoEndDate" [class.is-invalid]="endDateError"
                         [ngModel]="assistUserEndDateDisplay" (ngModelChange)="assistUserEndDateDisplay = maskDate($event)" (focus)="inputFocused($event)" (blur)="onEndDateBlur()">
                  <small *ngIf="endDateError" class="form-text text-danger">{{ endDateError }}</small>
                  <div class="form-check text-right">
                    <input class="form-check-input" type="checkbox" name="addNoEndDate" id="addNoEndDate" [(ngModel)]="isNoEndDate" (change)="checkNoEndDate($event)">
                    <label class="form-check-label mr-1 mt-1" for="addNoEndDate">
                      No End Date
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div *ngIf="addErrorMessage" class="alert alert-danger" role="alert">
              {{ addErrorMessage }}
            </div>
            <div class="text-center">
              <input type="submit" class="btn btn-secondary input-block-level" name="addButton" id="addButton" value="Add" [disabled]="saving">&nbsp;&nbsp;&nbsp;
              <input type="button" class="btn btn-danger input-block-level" value="Reset" (click)="resetAddForm()">
            </div>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
</div>
